<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column is-half">
        <search-form />
      </div>
    </div>
  </div>
</template>

<script>
import SearchForm from './SearchForm'

export default {
  name: 'TheSearch',
  components: { SearchForm }
}
</script>
